import styled, { keyframes } from "styled-components";

export default function LoadingText({ children = "讀取中" }) {
  return <Label>{children}<Dots aria-hidden="true"><span>.</span><span>.</span><span>.</span></Dots></Label>;
}

const bounce = keyframes`
  0%, 60%, 100% { transform: translateY(0); opacity: .45; }
  30% { transform: translateY(-.22em); opacity: 1; }
`;

const Label = styled.span`
  display: inline-flex;
  align-items: baseline;
  white-space: nowrap;
`;

const Dots = styled.span`
  display: inline-flex;
  > span { display: inline-block; animation: ${bounce} 1.2s ease-in-out infinite; }
  > span:nth-child(2) { animation-delay: .16s; }
  > span:nth-child(3) { animation-delay: .32s; }
  @media (prefers-reduced-motion: reduce) {
    > span { animation: none; opacity: 1; }
  }
`;
